import { useState, useEffect } from 'react';
import axios from 'axios';
import { useParams } from 'react-router-dom';
import { useGetSwapsQuery, useGetSwapsDateQuery, useCreateMessageChatMutation, useGetUsersByIdQuery } from '../app/apiSlice';
import { useNavigate } from 'react-router-dom';
import { useDispatch } from "react-redux";
import { fetchInfoCrewcode, fetchConversation } from '../app/slices';
import { useCreateConversationMutation } from '../app/apiSlice';
import { fetchSwapsDate } from '../app/slices';
import { useDeleteSwapMutation } from '../app/apiSlice';
import { getSwapsDate } from '../app/slices';


function Swap() {
    const [data, setData] = useState([]);
    const { cellDate } = useParams();
    const navigate = useNavigate()
    const [isOpen, setIsOpen] = useState(false);
    const [newMessage, setNewMessage] = useState("")
    const [errorConversation, setErrorConversation] = useState(false)
    const [succesConversation, setSuccesConversation] = useState(false)

    const RankUser = localStorage.getItem('Rank');
    const id = localStorage.getItem("IDUserLogin")
    const id2 = JSON.parse(id)
    const [conversationId, setConversationId] = useState(null); // state to store the conversation ID
    const dispatch = useDispatch()
    const [message, setMessage] = useState('');

    useEffect(() => {
        if (!id) {
            navigate("/login")
        }
    }, [])



    const [createChat] = useCreateConversationMutation();
    const [deleteSwap] = useDeleteSwapMutation()


    const [createMessage] = useCreateMessageChatMutation();
    const { data: dataIdQuery = [] } = useGetUsersByIdQuery()


    const { data: swapData = [], refetch } = useGetSwapsDateQuery(cellDate);
    console.log(swapData)
    const deleteSwapFunction = async (id) => {
        console.log(id)
        await deleteSwap({ id }).unwrap();
        window.location.reload()
    }
    const [nuevo, setNuevo] = useState([])
    useEffect(() => {
        async function fetchData() {
            const data = await dispatch(fetchSwapsDate(cellDate));
            setNuevo(data.payload);
        }
        fetchData();
    }, [dispatch, deleteSwap])
    console.log(nuevo)


    useEffect(() => {
        setData(nuevo);
    }, [nuevo, setData, conversationId]);



    const dataMatchSwap = data.filter((dataItem) => {
        if (JSON.parse(RankUser) === "JU") {
            return (dataItem.rank === RankUser || dataItem.rank === `"JUPU"`);
        } else if (JSON.parse(RankUser) === "JUPU") {
            return (dataItem.rank === `"JU"` || dataItem.rank === RankUser || dataItem.rank === `"PU"`);
        } else if (JSON.parse(RankUser) === "PU") {
            return (dataItem.rank === `"JUPU"` || dataItem.rank === RankUser);
        } else {
            // handle error case
            return false;
        }
    });
    const todo = async (receiverId) => {

        console.log("sadasd");
        console.log(receiverId);
        console.log(id2[0]);
        await createChat({ senderId: id2[0], receiverId: receiverId })

            .then((savedConversation) => {
                createMessage({ sender: id2[0], text: newMessage, conversationId: savedConversation.data._id })
                setNewMessage("")
                setIsOpen(false)
                setSuccesConversation(true)
            })
            .catch((error) => {
                console.error(error);
                setErrorConversation(true)
            });
    };


    return (
        <div>
            <h1>Swaps available</h1>
            {dataMatchSwap ? <div> {
                dataMatchSwap.map((item, index) => (
                    <div key={item._id} className="dia">
                        <h2>{item.tipoSwap}</h2>
                        <h5>CrewCode: {item.crewcode}</h5>
                        <h5>Start hour: {item.inicio}</h5>
                        <h5>End hour: {item.fin}</h5>
                        <h5>Roster: {item.roster}</h5>
                        <p>Reason/money: {item.razon}</p>
                        <p>{item.userId === id2[0]
                            ? <div></div>
                            : <div>
                                <button onClick={() => {
                                    setErrorConversation(false);
                                    setSuccesConversation(false);
                                    setIsOpen(prevState => ({ ...prevState, [index]: !prevState[index] }));
                                }}>Send a message</button>{isOpen[index] === true
                                    ? <>
                                        <div>
                                            <textarea name=""
                                                id=""
                                                cols="30"
                                                rows="10"
                                                placeholder="Write something..."
                                                onChange={(e) => setNewMessage(e.target.value)}
                                                value={newMessage}
                                                required
                                            >
                                            </textarea>
                                            <button onClick={() => todo(item.userId)}> Send </button>
                                        </div>
                                        {errorConversation
                                            ? <div>You have already a conversation</div>
                                            : <div></div>}

                                    </>
                                    : <></>}
                            </div>}
                            {item.userId === id2[0]
                                ? <div><button onClick={() => { deleteSwapFunction(item._id) }}>Borrar</button></div>
                                : <div></div>}

                            {succesConversation
                                ? <div>Message sent successfully</div>
                                : <div></div>}
                        </p>
                    </div>
                ))
            }</div> : <div>No swaps</div>}
        </div>
    );
}

export default Swap;
